/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Seatbelt Icon component.
 */
export const SeatbeltIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M12.25 10C13.9069 10 15.25 8.65685 15.25 7C15.25 5.34315 13.9069 4 12.25 4C10.5931 4 9.25 5.34315 9.25 7C9.25 8.65685 10.5931 10 12.25 10Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M18.25 20H6.25L17.5833 10' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M17.25 14C17.9019 14.8804 18.2509 15.9275 18.25 17' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M6.25 16C6.40619 15.0539 6.7941 14.1587 7.3807 13.3907C7.96731 12.6226 8.73522 12.0044 9.61907 11.5887C10.5029 11.173 11.4765 10.9721 12.4569 11.0031C13.4373 11.0342 14.3956 11.2962 15.25 11.767' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default SeatbeltIcon;
